/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Colors by modules
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */


import { ColorGrey1, ColorGreyLight1, ColorGreyLight2, ColorLink, Green, WarmRedC } from './palette';

export const constructorBasketBg = ColorGreyLight2;
export const constructorBasketSelected = ColorGrey1;
export const constructorBasketEmptySubs = WarmRedC;
export const constructorCardBorderHover = ColorGreyLight1;
export const constructorCardBorderActive = Green;
export const constructorCardButton = ColorLink;
